import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ClubRoutingModule } from './club-routing.module';
import { ClubComponent } from './club/club.component';
import { GroundRegulationsComponent } from './ground-regulations/ground-regulations.component';
import { AccessStatementComponent } from './access-statement/access-statement.component';
import { RecruitmentComponent } from './recruitment/recruitment.component';
import { GovernanceComponent } from './governance/governance.component';
import { ContactComponent } from './contact/contact.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ClubComponent, GroundRegulationsComponent, AccessStatementComponent, RecruitmentComponent, GovernanceComponent, ContactComponent],
  imports: [
    CommonModule,
    SlickCarouselModule,
    ClubRoutingModule,
    FormsModule,
    SharedModule
  ]
})
export class ClubModule { }
